/* eslint eqeqeq: off */
import React from "react";
import './index.css';
import Modal, {ModalAction, ModalContent, ModalControls} from "../../../Components/Modal";
import Button from "../../../Components/Control/Button";
import {connect} from "react-redux";
import moment from "jalali-moment";
import Resource from "../../../Resource";
import PropTypes from 'prop-types';
import {Tool} from "../../../App";
import ModalPrint from "../ModalPrint";
import Notif from "../../../Components/Notif";
import Patient from "../../../Server/Patient";
import MyComponent from '../../../Components/MyComponent';
import {OrganizationIrradiateRequest, SectionIrradiateRequest} from '../../../Server/IrradiateRequest';
import Label from "../../../Components/Control/Label";
import Radio from "../../../Components/Control/Radio";
import Group, {GroupTabContent} from "../../../Components/Group";
import Input from "../../../Components/Control/Input";
import ModalInjectionState from "../ModalInjectionState";
import Time from "../../../Components/Control/Time";
import Date from "../../../Components/Control/Date";
import LargeInput from "../../../Components/Control/LargeInput";
import {sha256} from "js-sha256";

class ModalInjectionMonitoring extends MyComponent {
    constructor(props) {
        super(props);
        props.refer.current = this;


        this.state = {
            error: null,
            loading: null,
            highlight: 1,
            fields: {},
            injectionValidate: false,
            groupTabs: [
                {id: 'validation', title: '1 صحت سنجی'},
                {id: 'injection', title: '2 فرآیند تزریق', disable: true},
                {id: 'injection-report', title: '3 گزارش نهایی تزریق', disable: true}
            ]
        };

        this.ref = {
            modal: React.createRef(),
            modalPrint: React.createRef(),
            modalInjectionState: React.createRef(),
            group: React.createRef(),
            insert: React.createRef(),
            update: React.createRef(),
            printLabel: React.createRef(),
        };
    }

    static defaultProps = {
        refer: {current: null},
        onClose: _ => null,
        onSuccess: _ => null
    };

    static propTypes = {
        refer: PropTypes.object,
        onClose: PropTypes.func,
        onSuccess: PropTypes.func
    };

    validations = {};

    componentDidMount() {


        this.setState({
            data: {
                key: 'c766c9a7398d38608a80d955f8e376bad6d22ed3fac37917c90a5e0b7c1f5b8f'
            }
        });
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        const {state, props} = this;

        return state.action !== nextState.action ||
            state.error !== nextState.error ||
            state.loading !== nextState.loading ||
            state.fields !== nextState.fields ||
            state.highlight !== nextState.highlight ||
            state.injectionValidate !== nextState.injectionValidate ||
            props.base.normRequestFormPrintOnSubmit !== nextProps.base.normRequestFormPrintOnSubmit;
    }

    render() {
        const {state, props} = this;
        const {fields} = state;
        const readOnly = state.action === ModalAction.VIEW;
        const groupTabs = [...state.groupTabs];

        groupTabs[1].disable = !state.injectionValidate;
        groupTabs[2].disable = !state.injectionValidate;

        return <React.Fragment>
            <Modal ref={this.ref.modal}
                   name={'ModalInjectionMonitoring'}
                   size={'large'}
                   title={'فرم نظارت بر تزریق'}
                   required={true}
                   error={this.state.error}
                   loading={this.state.loading}
                   onClose={this.props.onClose}>
                <ModalContent>
                    <Group tabs={state.groupTabs} ref={this.ref.group} defaultTab={'injection'}>
                        <GroupTabContent id={'validation'}>
                            <div className={`CheckCard ${state.highlight == 1 ? 'highlight' : null}`} onClick={this.highlightBlock.bind(this, 1)}>
                                <span>1</span>
                                <Label>شماره پرونده بیمار:</Label>
                                <Radio label={'6666666'} className={'pad-4 flex'} name={'patientFileCode'} checked={fields.patientFileCode == 1} onChange={this.setField.bind(this, 'patientFileCode', 1)}/>
                                <Radio label={'3333333'} className={'pad-4 flex'} name={'patientFileCode'} checked={fields.patientFileCode == 2} onChange={this.setField.bind(this, 'patientFileCode', 2)}/>
                                <Radio label={'1111111'} className={'pad-4 flex'} name={'patientFileCode'} checked={fields.patientFileCode == 3} onChange={this.setField.bind(this, 'patientFileCode', 3)}/>
                            </div>
                            <div className={`CheckCard ${state.highlight == 2 ? 'highlight' : null}`} onClick={this.highlightBlock.bind(this, 2)}>
                                <span>2</span>
                                <Label>نام و نام خانوادگی بیمار:</Label>
                                <Radio label={'فرشاد محمودی نژاد'} className={'pad-4 flex'} name={'patientFullName'} checked={fields.patientFullName == 1} onChange={this.setField.bind(this, 'patientFullName', 1)}/>
                                <Radio label={'جان اف کندی'} className={'pad-4 flex'} name={'patientFullName'} checked={fields.patientFullName == 2} onChange={this.setField.bind(this, 'patientFullName', 2)}/>
                                <Radio label={'محمود احمدی نژاد'} className={'pad-4 flex'} name={'patientFullName'} checked={fields.patientFullName == 3} onChange={this.setField.bind(this, 'patientFullName', 3)}/>
                            </div>
                            <div className={`CheckCard ${state.highlight == 3 ? 'highlight' : null}`} onClick={this.highlightBlock.bind(this, 3)}>
                                <span>3</span>
                                <Label>کدملی بیمار:</Label>
                                <Radio label={'1361399198'} className={'pad-4 flex'} name={'patientNationalCode'} checked={fields.patientNationalCode == 1} onChange={this.setField.bind(this, 'patientNationalCode', 1)}/>
                                <Radio label={'1377984753'} className={'pad-4 flex'} name={'patientNationalCode'} checked={fields.patientNationalCode == 2} onChange={this.setField.bind(this, 'patientNationalCode', 2)}/>
                                <Radio label={'1362202754'} className={'pad-4 flex'} name={'patientNationalCode'} checked={fields.patientNationalCode == 3} onChange={this.setField.bind(this, 'patientNationalCode', 3)}/>
                            </div>
                            <div className={`CheckCard ${state.highlight == 4 ? 'highlight' : null}`} onClick={this.highlightBlock.bind(this, 4)}>
                                <span>4</span>
                                <Label>تاریخ تولد بیمار:</Label>
                                <Radio label={'1373/01/29'} className={'pad-4 flex'} name={'patientBirthDate'} checked={fields.patientBirthDate == 1} onChange={this.setField.bind(this, 'patientBirthDate', 1)}/>
                                <Radio label={'1388/03/15'} className={'pad-4 flex'} name={'patientBirthDate'} checked={fields.patientBirthDate == 2} onChange={this.setField.bind(this, 'patientBirthDate', 2)}/>
                                <Radio label={'1349/04/01'} className={'pad-4 flex'} name={'patientBirthDate'} checked={fields.patientBirthDate == 3} onChange={this.setField.bind(this, 'patientBirthDate', 3)}/>
                            </div>
                            <div className={`CheckCard ${state.highlight == 5 ? 'highlight' : null}`} onClick={this.highlightBlock.bind(this, 5)}>
                                <span>5</span>
                                <Label>گروه خونی بیمار:</Label>
                                <Radio label={'A+'} className={'pad-4 flex'} name={'patientBloodGroup'} checked={fields.patientBloodGroup == 1} onChange={this.setField.bind(this, 'patientBloodGroup', 1)}/>
                                <Radio label={'B-'} className={'pad-4 flex'} name={'patientBloodGroup'} checked={fields.patientBloodGroup == 2} onChange={this.setField.bind(this, 'patientBloodGroup', 2)}/>
                                <Radio label={'AB+'} className={'pad-4 flex'} name={'patientBloodGroup'} checked={fields.patientBloodGroup == 3} onChange={this.setField.bind(this, 'patientBloodGroup', 3)}/>
                            </div>
                            <div className={`CheckCard ${state.highlight == 6 ? 'highlight' : null}`} onClick={this.highlightBlock.bind(this, 6)}>
                                <span>6</span>
                                <Label>شماره فرآورده:</Label>
                                <Radio label={'123546456454'} className={'pad-4 flex'} name={'productNumber'} checked={fields.productNumber == 1} onChange={this.setField.bind(this, 'productNumber', 1)}/>
                                <Radio label={'896513465453'} className={'pad-4 flex'} name={'productNumber'} checked={fields.productNumber == 2} onChange={this.setField.bind(this, 'productNumber', 2)}/>
                                <Radio label={'465413154654'} className={'pad-4 flex'} name={'productNumber'} checked={fields.productNumber == 3} onChange={this.setField.bind(this, 'productNumber', 3)}/>
                            </div>
                            <div className={`CheckCard ${state.highlight == 7 ? 'highlight' : null}`} onClick={this.highlightBlock.bind(this, 7)}>
                                <span>7</span>
                                <Label>گروه خونی فرآورده:</Label>
                                <Radio label={'B+'} className={'pad-4 flex'} name={'productBloodGroup'} checked={fields.productBloodGroup == 1} onChange={this.setField.bind(this, 'productBloodGroup', 1)}/>
                                <Radio label={'B-'} className={'pad-4 flex'} name={'productBloodGroup'} checked={fields.productBloodGroup == 2} onChange={this.setField.bind(this, 'productBloodGroup', 2)}/>
                                <Radio label={'AB+'} className={'pad-4 flex'} name={'productBloodGroup'} checked={fields.productBloodGroup == 3} onChange={this.setField.bind(this, 'productBloodGroup', 3)}/>
                            </div>
                            <div className={`CheckCard ${state.highlight == 8 ? 'highlight' : null}`} onClick={this.highlightBlock.bind(this, 8)}>
                                <span>8</span>
                                <Label>نوع فرآورده:</Label>
                                <Radio label={'WB'} className={'pad-4 flex'} name={'productType'} checked={fields.productType == 1} onChange={this.setField.bind(this, 'productType', 1)}/>
                                <Radio label={'FFP'} className={'pad-4 flex'} name={'productType'} checked={fields.productType == 2} onChange={this.setField.bind(this, 'productType', 2)}/>
                                <Radio label={'RBC'} className={'pad-4 flex'} name={'productType'} checked={fields.productType == 3} onChange={this.setField.bind(this, 'productType', 3)}/>
                            </div>
                            <div className={`CheckCard ${state.highlight == 9 ? 'highlight' : null}`} onClick={this.highlightBlock.bind(this, 9)}>
                                <span>9</span>
                                <Label>تاریخ انقضا:</Label>
                                <Radio label={'1400/01/05'} className={'pad-4 flex'} name={'productExpireDate'} checked={fields.productExpireDate == 1} onChange={this.setField.bind(this, 'productExpireDate', 1)}/>
                                <Radio label={'1400/01/06'} className={'pad-4 flex'} name={'productExpireDate'} checked={fields.productExpireDate == 2} onChange={this.setField.bind(this, 'productExpireDate', 2)}/>
                                <Radio label={'1400/01/25'} className={'pad-4 flex'} name={'productExpireDate'} checked={fields.productExpireDate == 3} onChange={this.setField.bind(this, 'productExpireDate', 3)}/>
                            </div>
                        </GroupTabContent>
                        <GroupTabContent id={'injection'}>
                            <div className={'Block pad-h-4 pad-v-14 mar-b-6'} style={{backgroundColor: 'var(--goo-red)'}}>
                                <Label> توجه: پرستار گرامی بسیار حیاتی است که قبل از تزریق موارد زیر را کنترل کنید.</Label>
                            </div>
                            <div className={`Block mar-b-6`}>
                                <div className={'pad-h-4 pad-v-14 dis-f'}>
                                    <span>10</span>
                                    <Label className={'flex'}>آیا هویت دریافت کننده خون (از طریق پرسش از خود بیمار در صورت هشیاری، اطلاعات مچ بند و شماره پرونده بیمار) با اطلاعات فرم مشخصات خون ارسالی برای بیمار و فرم درخواست خون با یکدیگر مطابقت دارد؟</Label>
                                </div>
                                <div className={'Block-content fb-20'}>
                                    <div className={'dis-f'}>
                                        <div className={'dis-f'} style={{marginTop: 'auto', backgroundColor: 'white', borderRadius: 5, color: 'black'}}>
                                            <Radio className={'pad-4'} style={{justifySelf: 'end'}} name={'patientIdentityCheck'} checked={fields.patientIdentityCheck === true} label={'بله'} onChange={this.setField.bind(this, 'patientIdentityCheck', true)}/>
                                            <Radio className={'pad-4'} name={'patientIdentityCheck'} checked={fields.patientIdentityCheck === false} label={'نه'} onChange={this.setField.bind(this, 'patientIdentityCheck', false)}/>
                                        </div>
                                        <Input className={'pad-4 flex'} name={'patientIdentityCheckDescription'} label={'توضیحات'} readOnly={fields.patientIdentityCheck !== false} value={fields.patientIdentityCheckDescription} onChange={this.setField.bind(this, 'patientIdentityCheckDescription')}/>
                                    </div>
                                </div>
                            </div>
                            <div className={`Block mar-b-6`}>
                                <div className={'pad-h-4 pad-v-14 dis-f'}>
                                    <span>11</span>
                                    <Label className={'flex'}>آیا مشخصات گروه خون و شماره اهداکننده روی کیسه خون با اطلاعات موجود بر روی فرم مشخصات خون ارسالی همخوانی دارد؟</Label>
                                </div>
                                <div className={'Block-content fb-20'}>
                                    <div className={'dis-f'}>
                                        <div className={'dis-f'} style={{marginTop: 'auto'}}>
                                            <Radio className={'pad-4'} style={{justifySelf: 'end'}} name={'productIdentityCheck'} checked={fields.productIdentityCheck === true} label={'بله'} onChange={this.setField.bind(this, 'productIdentityCheck', true)}/>
                                            <Radio className={'pad-4'} name={'productIdentityCheck'} checked={fields.productIdentityCheck === false} label={'نه'} onChange={this.setField.bind(this, 'productIdentityCheck', false)}/>
                                        </div>
                                        <Input className={'pad-4 flex'} name={'productIdentityCheckDescription'} label={'توضیحات'} readOnly={fields.productIdentityCheck !== false} value={fields.productIdentityCheckDescription} onChange={this.setField.bind(this, 'productIdentityCheckDescription')}/>
                                    </div>
                                </div>
                            </div>
                            <div className={`Block mar-b-6`}>
                                <div className={'pad-h-4 pad-v-14 dis-f'}>
                                    <span>12</span>
                                    <Label className={'flex'}>بررسی شرایط ظاهری کیسه فرآورده.</Label>
                                </div>
                                <div className={'Block-content fb-20'}>
                                    <div className={'dis-f'}>
                                        <div className={'dis-f'} style={{marginTop: 'auto'}}>
                                            <Label>تاریخ انقضا فرآورده:</Label>
                                            <Radio className={'pad-4'} style={{justifySelf: 'end'}} name={'productExpireCheck'} checked={fields.productExpireCheck === true} label={'مناسب'} onChange={this.setField.bind(this, 'productExpireCheck', true)}/>
                                            <Radio className={'pad-4'} name={'productExpireCheck'} checked={fields.productExpireCheck === false} label={'نامناسب'} onChange={this.setField.bind(this, 'productExpireCheck', false)}/>
                                        </div>
                                        <Input className={'pad-4 flex'} name={'productExpireCheckDescription'} label={'توضیحات'} readOnly={fields.productExpireCheck!==false} value={fields.productExpireCheckDescription} onChange={this.setField.bind(this, 'productExpireCheckDescription')}/>
                                    </div>
                                    <div className={'dis-f'}>
                                        <Label>بررسی وضعیت ظاهری کیسه:</Label>
                                        <Radio className={'pad-4'} style={{justifySelf: 'end'}} name={'productAppearanceCheck'} checked={fields.productAppearanceCheck === true} label={'مناسب'} onChange={this.setField.bind(this, 'productAppearanceCheck', true)}/>
                                        <Radio className={'pad-4'} name={'productAppearanceCheck'} checked={fields.productAppearanceCheck === false} label={'نامناسب'} onChange={this.setField.bind(this, 'productAppearanceCheck', false)}/>
                                    </div>
                                    <Input className={'pad-4 flex'} name={'needleAppearance'} label={'سایز یا رنگ سرسوزن مورد استفاده'}  value={fields.needleAppearance} onChange={this.setField.bind(this, 'needleAppearance')}/>
                                </div>
                            </div>
                            <div className={'Block pad-h-4 pad-v-14 mar-b-6'} style={{backgroundColor: 'var(--goo-red)'}}>
                                <Label>مهم: در صورت عدم استفاده از این فرآورده، آن را سریعا به بانک خون عودت دهید. فرآورده RBC حداکثر می تواند 30 دقیقه در دمای اتاق 20-24 پس از خروج از بانک خون در بخش نگهداری شود.</Label>
                            </div>
                            <div className={`Block`}>
                                <div className={'pad-h-4 pad-v-14 dis-f'}>
                                    <span>13</span>
                                    <Label className={'flex'}>ثبت علائم حیاتی بیمار</Label>
                                </div>
                                <div className={'Block-content fb-20'}>
                                    <table className={'Beauty-table'}>
                                        <tr className={'header'}>
                                            <td></td>
                                            <th>درجه حرارت</th>
                                            <th>فشارخون</th>
                                            <th>تعداد نبض</th>
                                            <th>تعداد تنفس</th>
                                            <th>حال عمومی بیمار</th>
                                            <th>ظاهر ادرار</th>
                                        </tr>
                                        <tr className={'error'} onClick={this.stateRowClickHandler.bind(this, 'start')}>
                                            <th>بلافاصله قبل از تزریق</th>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                        </tr>
                                        <tr className={'error'} onClick={this.stateRowClickHandler.bind(this, 'quarter')}>
                                            <th>طی 15 دقیقه بعد از شروع تزریق</th>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                        </tr>
                                        <tr className={'error'} onClick={this.stateRowClickHandler.bind(this, 'half-hour')}>
                                            <th>30 دقیقه بعد از شروع تزریق</th>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                        </tr>
                                        <tr className={'error'} onClick={this.stateRowClickHandler.bind(this, 'one-hour')}>
                                            <th>1 ساعت بعد از شروع تزریق</th>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                        </tr>
                                        <tr className={'error'} onClick={this.stateRowClickHandler.bind(this, 'two-hour')}>
                                            <th>2 ساعت بعد از شروع تزریق</th>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                        </tr>
                                        <tr className={'error'} onClick={this.stateRowClickHandler.bind(this, 'three-hour')}>
                                            <th>3 ساعت بعد از شروع تزریق</th>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                        </tr>
                                        <tr className={'error'} onClick={this.stateRowClickHandler.bind(this, 'four-hour')}>
                                            <th>4 ساعت بعد از شروع تزریق</th>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </GroupTabContent>
                        <GroupTabContent id={'injection-report'}>
                            <div className={'Block pad-h-4 pad-v-14 mar-b-6'} style={{backgroundColor: 'var(--goo-red)'}}>
                                <Label> توجه: در صورت تکمیل این قسمت امکان ویرایش تب‌های صحت سنجی و فرآیند تزریق را نخواهید داشت.</Label>
                            </div>
                            <div className={'Block pad-h-4 pad-v-14 mar-b-6'} style={{backgroundColor: 'var(--goo-yel)', color: '#555'}}>
                                <Label>اخطار: اطلاعات علائم حیاتی بیمار به طور کامل پر نشده است.</Label>
                            </div>
                            <div className={'mar-b-6'} style={{backgroundColor: 'white', borderRadius: 5}}>
                                <div className={'dis-f'}>
                                    <Radio label={'تزریق به پایان رسید:'} className={'pad-4 fb-20'} name={'injectionFinished'} checked={fields.injectionFinished == true} onChange={this.setField.bind(this, 'injectionFinished', true)}/>
                                    <Date label={'تاریخ تزریق خون'} className={'pad-4 fb-5'}/>
                                    <Time label={'ساعت شروع تزریق'} className={'pad-4 fb-5'}/>
                                    <Input label={'ساعت پایان تزریق'} className={'pad-4 fb-5'}/>
                                    <Input label={'حجم فرآورده تزریق شده'} className={'pad-4 fb-5'}/>
                                    <div className={'dis-f fb-20'} style={{marginTop: 'auto'}}>
                                        <Label className={'pad-4'}>آیا تزریق خون با بروز عارضه همراه بوده است؟</Label>
                                        <Radio label={'بله'} className={'pad-4'} name={'injectionComplication'} checked={fields.injectionComplication == true} onChange={this.setField.bind(this, 'injectionComplication', true)}/>
                                        <Radio label={'خیر'} className={'pad-4'} name={'injectionComplication'} checked={fields.injectionComplication == false} onChange={this.setField.bind(this, 'injectionComplication', false)}/>
                                    </div>
                                </div>
                            </div>
                            <div style={{backgroundColor: 'white', borderRadius: 5}}>
                                <div className={'dis-f'}>
                                    <Radio label={'تزریق صورت نگرفت:'} className={'pad-4 fb-20'} name={'injectionFinished'} checked={fields.injectionFinished == false} onChange={this.setField.bind(this, 'injectionFinished', false)}/>
                                    <LargeInput label={'توضیحات'} className={'pad-4 fb-20'}/>
                                </div>
                            </div>
                        </GroupTabContent>
                    </Group>
                </ModalContent>
                <ModalControls>
                    {state.action === ModalAction.UPDATE && <Button refer={this.ref.update} className={'mar-4'} theme={'yellow'} onClick={this.updateClickHandler.bind(this)}>ویرایش درخواست</Button>}
                    {state.action === ModalAction.INSERT && <Button refer={this.ref.insert} className={'mar-4'} theme={'blue'} onClick={this.insertClickHandler.bind(this)}>ثبت درخواست</Button>}
                    {!state.injectionValidate && <Button refer={this.ref.confirm} className={'mar-4'} theme={'blue'} onClick={this.confirmClickHandler.bind(this)}>بررسی صحت اطلاعات</Button>}
                    <Button refer={this.ref.close} className={'mar-4'} onClick={this.close.bind(this)}>بستن</Button>
                </ModalControls>
            </Modal>
            <ModalPrint refer={this.ref.modalPrint}/>
            <ModalInjectionState refer={this.ref.modalInjectionState}/>
        </React.Fragment>;
    }

    close(success) {
        this.ref.modal.current.close();

        if (success === true)
            this.props.onSuccess();

        this.props.onClose();
    }

    confirmClickHandler() {
        const {state} = this;

        console.log(state.data?.key, state?.key);
        if (state.data?.key === state?.key) {
            this.setState({injectionValidate: true});

            this.ref.group.current.goto('injection');

            new Notif('صحت اطلاعات وارد شده تایید شد می توانید فرآیند تزریق را آغاز کنید.').show();
            return
        }

        new Notif({message: 'ترکیب اطلاعات وارد شده صحیح نمی باشد.', theme: 'error'}).show();
    }

    fieldWillUpdate(keys, value, currentFields, nextFields) {
        switch (keys[0]) {
            case 'patientFileCode':
            case 'patientFullName':
            case 'patientNationalCode':
            case 'patientBirthDate':
            case 'patientBloodGroup':
            case 'productNumber':
            case 'productBloodGroup':
            case 'productType':
            case 'productExpireDate':
                const code = [];

                code.push(nextFields.patientFileCode || '');
                code.push(nextFields.patientFullName || '');
                code.push(nextFields.patientNationalCode || '');
                code.push(nextFields.patientBirthDate || '');
                code.push(nextFields.patientBloodGroup || '');
                code.push(nextFields.productNumber || '');
                code.push(nextFields.productBloodGroup || '');
                code.push(nextFields.productType || '');
                code.push(nextFields.productExpireDate || '');

                this.setState({
                    highlight: this.state.highlight + 1,
                    key: sha256(code.join('|'))
                });
                break;
            default:
        }
    }

    highlightBlock(id) {
        this.setState({highlight: id});
    }

    insertClickHandler() {
        const {ref, state} = this;

        if (this.validate()) {
            if (!state.patientFileInfo) {
                new Notif({message: 'شماره پرونده معتبر نمی باشد.', theme: 'error'}).show();
                return;
            }
            ref.insert.current.loading();
            this.setState({error: null});

            SectionIrradiateRequest.insert({
                patientFileCodeId: state?.patientFileInfo?.patientFileCodeId,
                predicteInjectionDateTime: state.fields?.predicteInjectionDateTime?.format() || null,
                probablyDiagnosticStr: state.fields?.probablyDiagnosticStr,
                peyvandOlozhinc: state.fields?.peyvandOlozhinc || false,
                sandron: state.fields?.sandron || false,
                faravardeh: state.fields?.faravardeh || false,
                darman: state.fields?.darman || false,
                platelet: state.fields?.platelet || false,
                vahed: state.fields?.vahed || false,
                nozad: state.fields?.nozad || false,
                peyvandOrgan: state.fields?.peyvandOrgan || false,
                tazrig: state.fields?.tazrig || false,
                bimari: state.fields?.bimari || false,
                lanfom: state.fields?.lanfom || false,
                anemy: state.fields?.anemy || false,
                docterId: state.fields?.docterId?.[0]?.id
            }).then(_ => {
                new Notif(Resource.STRING.FETCH.INSERT_SUCCESSFUL).show();

                ref.insert.current.loading(false);

                this.close(true);
            }).catch(message => {
                ref.insert.current.loading(false);

                this.setState({error: message});
            });
        }
    }

    open(data, action) {
        if (action === ModalAction.INSERT) {
            this.setState({
                data,
                action,
                fields: {},
                patientFileInfo: data.patientFileInfo,
                error: null
            });
        } else if (action === ModalAction.UPDATE || action === ModalAction.VIEW) {
            this.setState({
                data,
                action,
                fields: {},
                error: null,
                loading: 'در حال دریافت اطلاعات درخواست'
            });

            if (data?.sectionRequestId)
                SectionIrradiateRequest.data({sectionRequestId: data?.sectionRequestId})
                    .then(data => {
                        this.setState({
                            data,
                            fields: {
                                patientFileCode: data?.patientFileCode,
                                predicteInjectionDateTime: data?.predicteInjectionDateTime ? moment(data?.predicteInjectionDateTime) : null,
                                probablyDiagnosticStr: data?.probablyDiagnosticStr,
                                peyvandOlozhinc: data?.peyvandOlozhinc || false,
                                sandron: data?.sandron || false,
                                faravardeh: data?.faravardeh || false,
                                darman: data?.darman || false,
                                platelet: data?.platelet || false,
                                vahed: data?.vahed || false,
                                nozad: data?.nozad || false,
                                peyvandOrgan: data?.peyvandOrgan || false,
                                tazrig: data?.tazrig || false,
                                bimari: data?.bimari || false,
                                lanfom: data?.lanfom || false,
                                anemy: data?.anemy || false,
                                docterId: [{id: data?.docterId}]
                            },
                            patientFileInfo: {
                                patientFileCodeId: data?.patientFileCodeId,
                                patientFullName: `${data?.patientFirstName} ${data?.patientLastName}`,
                                patientBloodGroupStr: data?.patientBloodGroupStr,
                                patientBirthDate: data?.patientBirthDate
                            },
                            loading: null
                        });
                    })
                    .catch(message => {
                        this.setState({
                            error: message,
                            loading: null
                        });
                    });

            if (data?.hospitalRequestId)
                OrganizationIrradiateRequest.data({hospitalRequestId: data?.hospitalRequestId})
                    .then(data => {
                        this.setState({
                            data,
                            fields: {
                                predicteInjectionDateTime: data?.predicteInjectionDateTime ? moment(data?.predicteInjectionDateTime) : null,
                                probablyDiagnosticStr: data?.probablyDiagnosticStr,
                                peyvandOlozhinc: data?.peyvandOlozhinc || false,
                                sandron: data?.sandron || false,
                                faravardeh: data?.faravardeh || false,
                                darman: data?.darman || false,
                                platelet: data?.platelet || false,
                                vahed: data?.vahed || false,
                                nozad: data?.nozad || false,
                                peyvandOrgan: data?.peyvandOrgan || false,
                                tazrig: data?.tazrig || false,
                                bimari: data?.bimari || false,
                                lanfom: data?.lanfom || false,
                                anemy: data?.anemy || false,
                                docterId: [{id: data?.docterId}]
                            },
                            loading: null
                        });
                    })
                    .catch(message => {
                        this.setState({
                            error: message,
                            loading: null
                        });
                    });
        }

        this.ref.modal.current.open()
            .then(_ => {
                if (action === ModalAction.INSERT) {
                    this.ref.patientFileCode.current.focus();
                }
            });
    }

    patientFileCodeSubmitHandler(value) {
        if (!value) {
            this.setState({patientFileInfo: undefined});
        }

        if (value) {
            this.setState({
                patientFileInfo: undefined,
                loading: 'در حال دریافت پرونده بیمار'
            });

            Patient.data({
                patientFileCode: value
            })
                .then(data => {
                    this.setState({
                        patientFileInfo: data,
                        loading: false
                    });
                })
                .catch(message => {
                    this.setState({
                        patientFileInfo: undefined,
                        loading: false,
                    }, _ => {
                        new Notif({message, theme: 'error'}).show();
                    });
                });
        }
    }

    stateRowClickHandler(id) {
        this.ref.modalInjectionState.current.open(id);
    }

    updateClickHandler() {
        const {ref, state} = this;

        if (this.validate()) {
            ref.update.current.loading();
            this.setState({error: null});

            SectionIrradiateRequest.update({
                sectionRadiatedRequestId: state.data?.sectionRadiatedRequestId,
                patientFileCodeId: state?.patientFileInfo?.patientFileCodeId,
                predicteInjectionDateTime: state.fields?.predicteInjectionDateTime?.format() || null,
                probablyDiagnosticStr: state.fields?.probablyDiagnosticStr,
                peyvandOlozhinc: state.fields?.peyvandOlozhinc || false,
                sandron: state.fields?.sandron || false,
                faravardeh: state.fields?.faravardeh || false,
                darman: state.fields?.darman || false,
                platelet: state.fields?.platelet || false,
                vahed: state.fields?.vahed || false,
                nozad: state.fields?.nozad || false,
                peyvandOrgan: state.fields?.peyvandOrgan || false,
                tazrig: state.fields?.tazrig || false,
                bimari: state.fields?.bimari || false,
                lanfom: state.fields?.lanfom || false,
                anemy: state.fields?.anemy || false,
                docterId: state.fields?.docterId?.[0]?.id
            }).then(_ => {
                new Notif(Resource.STRING.FETCH.UPDATE_SUCCESSFUL).show();

                ref.update.current.loading(false);

                this.close(true);
            }).catch(message => {
                ref.update.current.loading(false);

                new Notif({message, theme: 'error'}).show();

                this.setState({error: message});
            });
        }
    }

    validate() {
        const {ref} = this;
        const validate = Tool.validate(ref.patientFileCode,
            ref.predicteInjectionDateTime,
            ref.probablyDiagnosticStr,
            ref.docterId
        );

        if (validate !== true)
            new Notif({message: validate.message, theme: 'error'}).show();

        return validate === true;
    }
}

const mapStateToProps = state => {
    return {
        base: state.base,
        user: state.user
    };
};

export default connect(mapStateToProps)(ModalInjectionMonitoring);